<template>
  <span
    :class="previewClass"
    @click="focusProperty"
    v-html="previewText"
  />
</template>

<script>
import { dateFormatter } from '../../../../translations';
import { empty } from "../../../../../js/util/util-functions";

export default {
  name: "adivare-preview-element",
  props: {
    property: {
      type: String,
      required: true,
    },
    translationOverride: {
      type: String,
      required: false,
      default: null,
    },
    previewTextOverride: {
      type: String,
      required: false,
      default: null,
    },
    focusOverride: {
      type: String,
      required: false,
      default: null,
    },
    showWhenEmpty: {
      type: Boolean,
      default: true,
      required: false,
    },
    previewClassOverride: {
      type: String,
      required: false,
      default: null,
    },
    previewClassPlaceholder: {
      type: String,
      required: false,
      default: null,
    },
    showPlaceholder: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isDate: null,
      previewText: '',
      previewClass: '',
    }
  },
  computed: {
    translationKey() {
      return this.translationOverride ?? this.property;
    },
    focusTarget() {
      return this.focusOverride ?? this.property;
    },
    formValue() {
      return this.$store.getters.getFormField(this.property);
    },
  },
  mounted() {
    const formField = this.$store.getters.getAdditionalFormField(this.property);

    this.isDate = undefined !== formField
      && true === formField.hasOwnProperty('type')
      && 'date' === formField.type;
  },
  watch: {
    formValue: {
        handler() {
          if (true === this.isDate) {
            this.previewText = this.previewDateText();
            return;
          }
          this.previewText = this.previewTextWithUserInput(this.formValue) ??
            this.previewTextPlaceholder(this.previewTextOverride) ?? (this.showWhenEmpty ?
              this.previewTextPlaceholder(this.$t(`messages_nl.label.${this.translationKey}`)) : '');
        },
        immediate: true,
      },
  },
  methods: {
    focusProperty() {
      this.$store.dispatch('focusInputRef', this.focusTarget);
    },
    previewDateText() {
      const value = this.$store.getters.getFormField(this.property);
      if ('string' === typeof value) {
        return value;
      }

      if (empty(value)) {
        return this.previewTextPlaceholder(this.previewTextOverride ??
          this.$t(`messages_nl.label.${this.translationKey}`));
      }

      return dateFormatter.format(value);
    },
    previewTextPlaceholder(text) {
      if (null === text || false === this.showPlaceholder) return null;
      this.previewClass = this.previewClassOverride ?
        this.previewClassOverride : 'text-fontcolor-light-grey inline-block text-sm';
      if (this.previewClassPlaceholder) this.previewClass += ' ' + this.previewClassPlaceholder;
      return `[${text}]*`;
    },
    previewTextWithUserInput(text) {
      if (null === text) return null
      this.previewClass = this.previewClassOverride ? this.previewClassOverride : '';
      if ('customerHouseNumberExtension' !== this.property) return text;
      // Add a dash to the house number extension if it contains a number
      if (/\d/.test(text)) return '-' + text;
      // Add margin if it doesn't contain a number
      if (!this.previewClassOverride) this.previewClass += this.previewClass ? ' ml-1.5' : 'ml-1.5';
      return text;
    }
  },
}
</script>
